export const SUPPORTED_NETWORKS = new Map([
  [
    1,
    {
      ensRegistry: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
      name: 'Ethereum Mainnet',
      type: 'main',
    },
  ],
  [
    4,
    {
      ensRegistry: '0x98df287b6c145399aaa709692c8d308357bc085d',
      name: 'Ethereum Rinkeby Testnet',
      type: 'rinkeby',
    },
  ],
  [
    137,
    {
      ensRegistry: '0x3c70a0190d09f34519e6e218364451add21b7d4b',
      name: 'Polygon Mainnet',
      type: 'matic',
    },
  ],
  [
    80001,
    {
      ensRegistry: '0x431f0eed904590b176f9ff8c36a1c4ff0ee9b982',
      name: 'Polygon Mumbai Testnet',
      type: 'mumbai',
    },
  ],
  [
    421611,
    {
      ensRegistry: '0x206edd024d8ac4df5e8953619ea8355b91248af1',
      name: 'Arbitrum Testnet',
      type: 'rinkarby',
    },
  ],
  [
    1666700000,
    {
      ensRegistry: '0xbc7828fa8665c637901ad5abd5c7e647c9ab140f',
      name: 'Harmony Testnet',
      type: 'harmonyTest',
    },
  ],
  [
    1666600000,
    {
      ensRegistry: '0x843ddfab8406e752d03fa75dbb275070f368658d',
      name: 'Harmony',
      type: 'harmony',
    },
  ],
  [
    97,
    {
      ensRegistry: '0x843ddfab8406e752d03fa75dbb275070f368658d',
      name: 'Bsc Testnet',
      type: 'bscTest',
    },
  ],
  [
    588,
    {
      ensRegistry: '0x843ddfab8406e752d03fa75dbb275070f368658d',
      name: 'Metis Stardust Testnet',
      type: 'stardust',
    },
  ],
  [
    1088,
    {
      ensRegistry: '0x843ddfab8406e752d03fa75dbb275070f368658d',
      name: 'Metis Andromeda Mainnet',
      type: 'andromeda',
    },
  ],
])
